import { defineModule } from "direct-vuex"

import * as ListModule from './ListModule'
import * as SingleModule from './SingleModule'
import * as SubItemModule from './SubItemModule'

export const internal = {
    namespaced: true as const,
    modules: {
        list: ListModule.module,
        single: SingleModule.module,
        sub_item: SubItemModule.module
    }
}

export const module = defineModule(internal)

export default module
